import { doc, getDoc } from 'firebase/firestore'
import { db } from './firebase'


//databaseの情報を返す(Promiseでラップされた値)
// 第一引数: 難易度
// 第二引数: 取得する文章のId
export async function getOriginalSentence(teacherId, sentenceId) {
  //usersのdocumentを取得
  const teacherRef = doc(db, 'original_sentence', teacherId);
  const docSnap = await getDoc(teacherRef);
  const data = docSnap.data();

  if (sentenceId != undefined) {
    return data[sentenceId];
  } else {
    return data;
  }
}
